import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Wrapper,
  LogoWrapper,
  IconMainWrapper,
  IconCloseWrapper,
  Head
} from './styled';
import * as LogoClasificados from '@app/src/assets/img/logo-clasificados.png';
import { isClientEnv } from '@app/src/utils/validations';
import { Icon } from '@app/src/common/Icon';
import { AsideModal } from '@app/src/common/AsideModal';
import {
  clearLoginData,
  clearValidateData,
  fetchLogout,
  putUser,
  setUserName
} from '@app/src/common/session';
import { useHistory } from 'react-router-dom';
import { MainList } from '@app/src/common/header';
import { setLogoutValue } from '@app/src/common/session/state/logout/actions';
import { IdleTimer } from '@app/src/utils/session';

const isClient = isClientEnv();

export const Logo: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const userStorage = isClient && JSON.parse(localStorage.getItem('user'));
  const currentUser = useSelector(state => state.session.user.name);
  const isLogout = useSelector(state => state.session.logout.isLogout);
  const isLoadingLogout = useSelector(state => state.session.logout.isFetching);
  const typePayment = useSelector(state => state.session.user.payment);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isTimeout, setIsTimeout] = useState(false);

  useEffect(() => {
    const timer = new IdleTimer({
      timeout: 60 * 60,
      onTimeout: () => {
        setIsTimeout(true);
      },
      onExpired: () => {
        setIsTimeout(true);
      }
    });

    return () => {
      timer.cleanUp();
    };
  });

  useEffect(() => {
    if (isTimeout) {
      if (userStorage && userStorage.jwt) {
        if (userStorage && userStorage.isLogin === false && userStorage.payment === 'purchase-package') {
          dispatch(putUser(userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id));
        }
        dispatch(fetchLogout({ jwt: userStorage.jwt }, userStorage.jwt));
        dispatch(clearValidateData())
      }
    }
  }, [isTimeout]);


  useEffect(() => {
    if (userStorage && userStorage.data && userStorage.data.name && userStorage.jwt) {
      dispatch(setUserName(userStorage.data.name))
    }
  }, []);

  useEffect(() => {
    if (isLogout) {
      dispatch(clearLoginData());
      dispatch(setUserName(''));
      dispatch(setLogoutValue(false));
      setIsOpenModal(false);
      history.push('/inicia-tu-sesion');
    }
  }, [isLogout, typePayment]);

  const handleModal = () => {
    setIsOpenModal(false);
  };

  const handleClickOpen = () => {
    setIsOpenModal(true);
  };

  const handleClick = () => {
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'MenuClasificados',
        'eventAction': 'Logo',
        'eventLabel': '',
        'eventValue': 1
      })
    }
  };

  const handleClickCloseSession = (e) => {
    e.preventDefault();
    if (userStorage && userStorage.jwt) {
      dispatch(fetchLogout({ jwt: userStorage.jwt }, userStorage.jwt));
      if (userStorage && userStorage.isLogin === false && userStorage.payment === 'purchase-package') {
        dispatch(putUser(userStorage && userStorage.user || userStorage && userStorage.data && userStorage.data.id));
      }
    } else {
      isClient && localStorage.removeItem('user');
      dispatch(setUserName(''));
    }
  };

  const handleClickInitSession = (e) => {
    e.preventDefault();
    setIsOpenModal(false);
    const updateUser = { ...userStorage };
    delete updateUser.uniqueId;
    delete updateUser.payment;
    localStorage.setItem('user', JSON.stringify(updateUser));
    history.push('/inicia-tu-sesion');
  };

  const handleClickAccount = () => {
    setIsOpenModal(false);
    if (isClient) {
      (window as any).location.href = '/mi-cuenta';
    }
  };

  const handleClickItem = () => {
    setIsOpenModal(false);
  };

  return (
    <Wrapper>
      <IconMainWrapper onClick={handleClickOpen}>
        <Icon data-name="icon-main" width="20" height="20" fill="#000" />
      </IconMainWrapper>
      <LogoWrapper
        href="/"
        onClick={() => handleClick()}>
        <img
          src={LogoClasificados}
          alt="clasificados.pe" />
      </LogoWrapper>
      <AsideModal
        minWidth={360}
        isOpen={isOpenModal}
        handleClickOutSide={handleModal}
      >
        <div>
          <Head>
            <IconCloseWrapper onClick={handleModal}>
              <Icon data-name="icon-close-bold" width="20" height="20" fill="#757575" />
            </IconCloseWrapper>
            <LogoWrapper
              href="/"
              onClick={() => handleClick()}>
              <img
                src={LogoClasificados}
                alt="clasificados.pe" />
            </LogoWrapper>
          </Head>
          <MainList
            userName={currentUser}
            handleClickInitSession={handleClickInitSession}
            handleClickCloseSession={handleClickCloseSession}
            handleClickAccount={handleClickAccount}
            handleClickItem={handleClickItem}
            isLoadingLogout={isLoadingLogout} />
        </div>
      </AsideModal>
    </Wrapper>
  );
};

Logo.displayName = 'Logo';
